type SecretResult = {
  data: Record<string, unknown> | null;
  error: Error | null;
};

/**
 * Securely fetch secrets from the server-side API
 * This function does not expose AWS credentials in the frontend
 */
export const fetchSecretFromApi = async (
  secretName: string
): Promise<SecretResult> => {
  try {
    const response = await fetch("/api/get-secret", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ secretName }),
    });

    if (!response.ok) {
      throw new Error(`Error fetching secret: ${response.statusText}`);
    }

    const result = await response.json();
    return {
      data: result.data,
      error: null,
    };
  } catch (error) {
    if (error instanceof Error) {
      console.error("Error fetching secret:", error);
      return {
        data: null,
        error: error,
      };
    }

    return {
      data: null,
      error: new Error("An unknown error occurred"),
    };
  }
};
